import { render } from "./AnalyseForPlant.vue?vue&type=template&id=92134fb2"
import script from "./AnalyseForPlant.vue?vue&type=script&lang=js"
export * from "./AnalyseForPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__